export default "__VITE_ASSET__DmfDZZF1__"